export default __webpack_public_path__ + "static/media/re.7e8577e9.svg";